/**
 * The success mark — one 56px circle, drawn as one `icon` component wherever the flow confirms something.
 *
 * Read live 2026-09-14 from both frames that instance it: `That's it for now — Desktop` (12302:30396) and
 * `13 · Pay card linked — Desktop` (12389:15932) draw the identical 56px `#eaf7de` circle around a 26px
 * `#16a34a` glyph. Two consumers is why it sits here rather than in `features/finish/` [skill § 4 — one
 * consumer means it lives with that consumer, two means it is shared].
 *
 * `aria-hidden`: the heading beside it already says the same thing, and a screen reader announcing a
 * decorative tick before reading "Your next steps" or "Your pay card is linked" is noise rather than
 * information. That is also what keeps the pair clear of § 9 — it carries no state by colour, because it
 * carries no state at all.
 */
export function SuccessBadge() {
  return (
    <div
      aria-hidden
      className="flex size-14 items-center justify-center rounded-full bg-[var(--success-muted)]"
    >
      {/*
        26px glyph inside a 56px circle. Sized to the GLYPH, not the circle — sizing an inset glyph to its
        containing box is how a chevron on this project came out 2× and then 4× too large in one review.
      */}
      <svg
        className="size-[26px]"
        fill="none"
        stroke="var(--success-foreground)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        viewBox="0 0 26 26"
      >
        <path d="M6 13.5 10.5 18 20 8" />
      </svg>
    </div>
  );
}
